import PropTypes from 'prop-types';
import { GECKO_CONSTS } from '../constants';

export const GeckoAvatarModel = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.oneOf([
    GECKO_CONSTS.AVATAR_SIZE_LARGE,
    GECKO_CONSTS.AVATAR_SIZE_SMALL,
  ]),
  bgImage: PropTypes.string,
};
